import { render, staticRenderFns } from "./Bell.vue?vue&type=template&id=01d15eaf&"
import script from "./Bell.vue?vue&type=script&lang=ts&"
export * from "./Bell.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports